import localeText from "../../../../locale";

import { useRef, useState } from "react";
import CategoryService from "../../../../service/CategoryService";
import "./NewCategories.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";

const NewCategories = (props) => {
  const categoryService = new CategoryService();
  const toast = useRef(null);

  const [descriptionEN, setDescriptionEN] = useState(props?.isEdit ? props?.descriptionEN : "");
  const [descriptionES, setDescriptionES] = useState(props?.isEdit ? props?.descriptionES : "");
  const [descriptionIT, setDescriptionIT] = useState(props?.isEdit ? props?.descriptionIT : "");
  const [descriptionPT, setDescriptionPT] = useState(props?.isEdit ? props?.descriptionPT : "");
  const [newImage, setNewImage] = useState(false);

  const [images, setImages] = useState(null);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const fileUploadRef = useRef(null);

  const uploadOptions = {
    className: "hidden",
  };

  async function uploadImages(image) {
    try {
      const res = await categoryService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
      }
    }
  }

  async function registerCategory() {
    try {
      setLoadingRegister(true);
      let uploadimage = null;

      if (
        (images?.length > 0 && !props.isEdit) ||
        (props.isEdit && newImage && images?.length > 0)
      ) {
        uploadimage = await uploadImages(images[0]);
      } else if (props.isEdit && !newImage) {
        uploadimage = props.images;
      } else {
        setLoadingRegister(false);
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("pleaseUploadAtLeastOne"),
          life: 6000,
        });
        return;
      }

      let res;

      if (!props?.isEdit)
        res = await categoryService.postRegisterCategory(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES,
          uploadimage
        );
      else
        res = await categoryService.postEditCategory(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES,
          uploadimage,
          props.id
        );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        window.location.href = "/listcategory";
        if (res.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  return (
    <>
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {props.isEdit ? localeText("edit") : localeText("addNewCategory")}
        </h1>
      </div>
      <div className="card border-1 border-300">
        <div className="mb-4">
          <h3 className="my-4">{localeText("categoryInfo")}</h3>
          <p className="text-600">{localeText("categoryFields")}</p>
          <div className="grid mt-6">
            <div className="col-12">
              <label htmlFor="descriptionEN">{localeText("descriptionEN")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionEN"
                value={descriptionEN}
                onChange={(e) => setDescriptionEN(e.target.value)}
              />
              <label htmlFor="descriptionES">{localeText("descriptionES")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionES"
                value={descriptionES}
                onChange={(e) => setDescriptionES(e.target.value)}
              />
              <label htmlFor="descriptionIT">{localeText("descriptionIT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionIT"
                value={descriptionIT}
                onChange={(e) => setDescriptionIT(e.target.value)}
              />
              <label htmlFor="descriptionPT">{localeText("descriptionPT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionPT"
                value={descriptionPT}
                onChange={(e) => setDescriptionPT(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label htmlFor="imageCategory">
                <span>{localeText("categoryImage")}</span>
              </label>

              <FileUpload
                uploadOptions={uploadOptions}
                chooseLabel={localeText("choose")}
                cancelLabel={localeText("cancel")}
                className="mt-2"
                name="imageCategory"
                onSelect={(e) => {
                  if (e.files.length <= 1 && e.files.length > 0) {
                    let error = false;

                    Array.from(e.files).forEach((file) => {
                      if (file.size / 1024 / 1024 > 1) {
                        setImages(null);
                        if (props.isEdit) setNewImage(false);

                        fileUploadRef.current.clear();
                        toast.current.show({
                          severity: "error",
                          summary: localeText("error"),
                          detail: localeText("fileSizeTooBig"),
                          life: 6000,
                        });
                        error = true;
                        return false;
                      }
                    });

                    if (!error) {
                      const arrImages = images ? [...images] : [];
                      Array.from(e.files).forEach((file) => {
                        arrImages.push(file);
                      });
                      setNewImage(true);
                      setImages(arrImages);
                    }
                  } else {
                    setImages(null);
                    if (props.isEdit) setNewImage(false);
                    toast.current.show({
                      severity: "error",
                      summary: localeText("error"),
                      detail: localeText("youCanOnlyChooseUpTo5"),
                      life: 6000,
                    });
                    fileUploadRef.current.clear();
                  }
                }}
                onClear={() => {
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onRemove={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onError={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                onValidationFail={() => {
                  fileUploadRef.current.clear();
                  setImages(null);
                  if (props.isEdit) setNewImage(false);
                }}
                accept="image/*"
                ref={fileUploadRef}
                multiple
                emptyTemplate={
                  <div className="text-center">
                    <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                    <h3 className="text-400">{localeText("dragImg")}</h3>
                  </div>
                }
              />
              <p className="text-600 mt-2">(max. 5 MB)</p>

              <div className="d-flex align-items-end flex-column">
                <Button
                  label={localeText("registerCategory")}
                  loading={loadingRegister}
                  className="mr-2 w-full lg:w-auto md:w-auto m-1"
                  onClick={() => registerCategory(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewCategories;
